import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=02ce7d86&scoped=true&"
import script from "./UploadComponent.vue?vue&type=script&lang=js&"
export * from "./UploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ce7d86",
  null
  
)

export default component.exports